import { Component, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { LoginService } from '../../../auth/login.service';
import { AlertService } from '../../../../shared/components/alert/alert';
import { AlertComponent } from '../../../../shared/components/alert/alert/alert';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-login-form',
  imports: [CommonModule, ReactiveFormsModule, AlertComponent, TranslatePipe],
  templateUrl: './login-form.html',
  styleUrl: './login-form.css',
})
export class LoginForm {
  loginForm: FormGroup;
  isLoading = false;
  errorMessage = '';
  showPassword = false;

  constructor(
    private fb: FormBuilder, 
    private loginService: LoginService,
    private router: Router,
    private alertService: AlertService,
    private cdr: ChangeDetectorRef
  ) {
    this.loginForm = this.fb.group({
      phone: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';
      const { phone, password } = this.loginForm.value;
      
      this.loginService.login(phone, password).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          if (response.returncode === '300') {
            console.log('Login successful', response);
            this.alertService.success('Login successful!');
            this.router.navigate(['/admin/dashboard']);
          } else {
            this.errorMessage = response.message || 'Login failed. Please try again.';
            this.alertService.error(this.errorMessage);
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.errorMessage = error?.error?.message || 'Login failed. Please try again.';
          this.alertService.error(this.errorMessage);
          console.error('Login error', error);
        }
      });
    } else {
      this.loginForm.markAllAsTouched();
    }
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
    this.cdr.detectChanges();
  }
}
